/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class V3StackAdaptTacticWeekDayRule {
    /**
    * List of days of the week for the creative tactic (e.g., 'MONDAY', 'TUESDAY', etc.)
    */
    'weekdays'?: Array<string>;
    /**
    * Whether the weekday rule is negative (i.e., the tactic is active on all days except those specified)
    */
    'negative'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "weekdays",
            "baseName": "weekdays",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "negative",
            "baseName": "negative",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptTacticWeekDayRule.attributeTypeMap;
    }

    public constructor() {
    }
}

